import { UserPermission } from '@cobliteam/common-types';

export const permissionsDependencies = new Map<UserPermission, UserPermission>([
  [UserPermission.CREATE_UPDATE_DELETE_ROUTES, UserPermission.VIEW_ROUTES],
  [UserPermission.CREATE_UPDATE_DELETE_PLACES_OF_INTEREST, UserPermission.VIEW_PLACES_OF_INTEREST],
  [UserPermission.CONFIG_FUEL_CARD, UserPermission.VIEW_FUEL_CARD],
  [UserPermission.WRITE_FLEET_EXPENSES, UserPermission.VIEW_FLEET_EXPENSES],
  [UserPermission.REQUEST_CAMERA_MEDIA, UserPermission.VIEW_CAMERA_MEDIA],
  [UserPermission.CREATE_UPDATE_DELETE_USERS_AND_INVITES, UserPermission.VIEW_USERS_AND_INVITES],
  [UserPermission.WRITE_FLEET_SAFETY, UserPermission.VIEW_FLEET_SAFETY],
]);
